export type CalendarSyncSummary = {
  last_sync_status?: string | null;
} | null | undefined;

export function classEventSeries<T extends { source_event_id: string; status: string; all_day: boolean }>(
  preview: T[],
): T[] {
  const seen = new Set<string>();
  return preview.filter((event) => {
    if (event.status === 'cancelled' || event.all_day || seen.has(event.source_event_id)) return false;
    seen.add(event.source_event_id);
    return true;
  });
}

export function selectedClassEvents<T extends { source_event_id: string; status: string; all_day: boolean }>(
  preview: T[], mode: 'all' | 'selected', selected: string[],
): T[] {
  const ids = new Set(selected);
  return preview.filter((event) => event.status !== 'cancelled' && !event.all_day
    && (mode === 'all' || ids.has(event.source_event_id)));
}

export function calendarLinkValidationError(value: string): string | null {
  const link = value.trim();
  if (!link) return null;

  let parsed: URL;
  try {
    parsed = new URL(link);
  } catch {
    return 'Enter the full calendar subscription link, including its address.';
  }

  if (parsed.protocol !== 'https:' && parsed.protocol !== 'webcal:') {
    return 'Use a subscription link that starts with https:// or webcal://.';
  }
  if (!parsed.hostname) {
    return 'Enter a complete calendar subscription link.';
  }
  return null;
}

export function calendarConnectionLabel(connection: CalendarSyncSummary): string {
  if (!connection) return 'Not connected';
  if (connection.last_sync_status === 'success') return 'Connected';
  if (connection.last_sync_status === 'failed') return 'Connection issue';
  return 'Syncing';
}

export function calendarEmptyPreviewMessage(connection: CalendarSyncSummary): string {
  if (!connection) return 'Connect a school calendar to preview upcoming classes.';
  if (connection.last_sync_status === 'success') {
    return 'Calendar connected and up to date, but no upcoming classes were found in the synced window.';
  }
  if (connection.last_sync_status === 'failed') {
    return 'No saved classes are available to show. Check the calendar connection and try again.';
  }
  return 'Your calendar is connecting. Upcoming classes will appear after the first sync.';
}
